/*
 * Copyright (c) 2026 Centrica.  All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * Date: 2026-10-08
 */

import { Provider, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NEBULA_TASKS_NAVIGATOR, NebulaTasksNavigator, NebulaToastService } from 'nebula-ui-kit';
import { TranslationService, rutaEnProductoActivo } from '@nebula-shared/data-access';
import { GlobalMenuSearchService } from '../../../../data-access/src/lib/global-menu-search.service';
import { CENTRO_TAREAS_PATH } from '../../../../layout.routes';

/**
 * Navegador al «Centro de Tareas» que lo abre en SU pestaña, como el menu (HT_ARQ_013, RN-TAR-079).
 *
 * <p>Navegar solo con el router dejaba el Centro dentro de la pestaña activa: la bandeja de la
 * barra superior y el «Ver tarea» del aviso no abrian la opcion. Se abre la opcion del menu del
 * producto activo por el mismo camino del buscador global (activa la pestaña si ya esta abierta y
 * respeta el tope de pestañas); con `jobId`, despues se elige la tarea por `?tarea=`.</p>
 *
 * @returns el proveedor que reemplaza al navegador por defecto de `provideNebulaImportExport`.
 */
export function provideNavegadorCentroTareas(): Provider {
  return {
    provide: NEBULA_TASKS_NAVIGATOR,
    useFactory: (): NebulaTasksNavigator => {
      const router = inject(Router);
      const buscador = inject(GlobalMenuSearchService);
      const avisos = inject(NebulaToastService);
      const traduccion = inject(TranslationService);
      return (jobId?: string) => {
        const opcion = buscador.optionForRoute(CENTRO_TAREAS_PATH);
        if (opcion && buscador.openOption(opcion) === 'limit') {
          avisos.warning(traduccion.translate('COMMON.ERROR.MAX_TABS_OPEN'));
          return;
        }
        const ruta = rutaEnProductoActivo(router.url, CENTRO_TAREAS_PATH);
        if (jobId || !opcion) {
          void router.navigate([ruta], jobId ? { queryParams: { tarea: jobId } } : {});
        }
      };
    },
  };
}
